import { DatePipe } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { TheftReport } from '../../../../types';

type CellParams = ICellRendererParams<TheftReport>;

@Component({
  selector: 'app-pan-cell-theft-report-review-id',
  imports: [MatIconModule, MatTooltipModule, DatePipe],
  templateUrl: './cell-theft-report-review-id.component.html',
})
export class CellTheftReportReviewIdComponent implements ICellRendererAngularComp {
  public params!: CellParams;

  agInit(params: CellParams) {
    this.params = params;
  }

  refresh(params: CellParams) {
    this.params = params;
    return true;
  }
}
